/**
* Drawer Script
* ------------------------------------------------------------------------------
* Exposes methods and events for the opening and closing of drawer elements that slide out from the side of the screen
*
* @namespace - drawer
*/

var utils = require('../../utilities/js/utils');
var $window = $(window);
var $body   = $('body');

var selectors = {
    close: '[data-drawer-close]'
}

var classes = {
    drawer: 'drawer',
    drawerOpen: 'is-open',
    backdrop: 'drawer-backdrop',
    backdropVisible: 'is-visible',
    bodyDrawerOpen: 'drawer-open'
};

/**
* Drawer Constructor
*
*/
function Drawer(el) {
    this.name = 'drawer';
    this.namespace = '.' + this.name;

    this.$el                = $(el);
    this.$backdrop          = null;
    this.stateIsOpen        = null;
    this.transitionEndEvent = utils.whichTransitionEnd();

    if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {

        return;
    }

    this.$el.on('click', selectors.close, this.onCloseClick.bind(this));

    return this;
};

Drawer.prototype = $.extend({}, Drawer.prototype, {
    onCloseClick: function(e) {
        e.preventDefault();
        this.close();
    },

    addBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(this.stateIsOpen) {
            this.$backdrop = $(document.createElement('div'));

            this.$backdrop.addClass(classes.backdrop)
            .appendTo($body);

            this.$backdrop.one(this.transitionEndEvent, cb);
            this.$backdrop.one('click', this.close.bind(this))

            // debug this...
            setTimeout(function() {
                _this.$backdrop.addClass(classes.backdropVisible);
            }, 10);
        }
        else {
            cb();
        }
    },

    removeBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(!this.stateIsOpen && this.$backdrop) {
            this.$backdrop.one(this.transitionEndEvent, function(){
                _this.$backdrop && _this.$backdrop.remove()
                _this.$backdrop = null;
                cb();
            });

            setTimeout(function() {
                _this.$backdrop.removeClass(classes.backdropVisible);
            }, 10);
        }
        else {
            cb();
        }
    },

    /**
    * Opens / closes the drawer depending on state
    *
    */
    toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
    },

    /**
    * Check the open / closed state of the drawer
    *
    * @return {bool}
    */
    isOpen: function() {
        return this.stateIsOpen;
    },

    /**
    * Returns true is the drawer is closed.
    *
    * @return {bool}
    */
    isClosed: function() {
        return !this.stateIsOpen;
    },

    /**
    * Code for opening the drawer
    */
    open: function() {
        if(this.stateIsOpen) return;
        this.stateIsOpen = true;

        $body.addClass(classes.bodyDrawerOpen);
        this.$el.addClass(classes.drawerOpen);
        this.addBackdrop();
    },

    /**
    * Code for closing the drawer
    */
    close: function() {
        if(!this.stateIsOpen) return;
        this.stateIsOpen = false;

        this.$el.removeClass(classes.drawerOpen);
        this.removeBackdrop(function() {
            $body.removeClass(classes.bodyDrawerOpen);
        });
    }
});

module.exports = Drawer;



//////////////////
// WEBPACK FOOTER
// ./drawer/js/drawer.js
// module id = 145
// module chunks = 3